import React from "react";
import { AgGridReact } from "ag-grid-react";
import { themeQuartz, colorSchemeDarkBlue } from "ag-grid-community";

interface AgGridTableProps {
  rowData: any;
  colDefs: any;
  loading?: boolean;
  height?: string;
  bottomBorder?: string;
  rowHeight?: number;
  pagination?: boolean;
  pageSize?: number;
  total?: number;
  page?: number;
  pageChange?: (page: any) => void;
  pageSizeChange?: (page: number) => void;
  className?: string;
  defaultColDef?: Record<string, unknown>;
}

const theme = themeQuartz.withPart(colorSchemeDarkBlue).withParams({
  backgroundColor: "#0A0e14",
  foregroundColor: "#EFF2FF",
  accentColor: "#242A2F",
  headerBackgroundColor: "#242A2F",
  headerTextColor: "rgba(239, 242, 255, 60%)",
  borderColor: "#0A0e14",
} as any);

const AgGridTable = ({
  rowData,
  colDefs,
  loading = false,
  height = "200px",
  bottomBorder = "#0A0e14",
  rowHeight = 40,
  pagination = false,
  pageSize = 10,
  page = 0,
  total = 0,
  pageChange = () => {},
  pageSizeChange = () => {},
  className = "",
  defaultColDef: defaultColDefProp,
}: AgGridTableProps) => {
  const defaultColDef = defaultColDefProp ?? {
    flex: 1,
    resizable: true,
    sortable: true,
    filter: true,
  };

  return (
    <div
      className={`flex flex-col justify-between ${className}`}
      style={{ width: "100%", height: height }}
    >
      <AgGridReact
        rowData={rowData as any[]}
        getRowStyle={() => ({
          borderBottom: `1px solid ${bottomBorder}`,
        })}
        rowHeight={rowHeight}
        columnDefs={colDefs as any[]}
        defaultColDef={defaultColDef}
        loading={loading}
        theme={theme}
      />
      {pagination && (
        <div className="flex justify-end items-center gap-4 mt-5">
          <div className="flex items-center gap-2 text-white">
            <p>Page Size :</p>
            <select
              className="ml-2 px-2 py-1 rounded bg-gray text-white"
              value={pageSize}
              onChange={(e) => {
                pageSizeChange(Number(e.target.value));
                pageChange(1);
              }}
            >
              {[10, 20, 50, 100].map((size) => (
                <option key={size} value={size}>
                  {size}
                </option>
              ))}
            </select>
          </div>
          <button
            className="px-3 py-1 rounded bg-gray text-white disabled:opacity-50"
            onClick={() => pageChange((p: number) => Math.max(1, p - 1))}
            disabled={page === 1}
          >
            {`<`}
          </button>
          <span className="text-primaryText">
            Page {page} of {Math.ceil(total / pageSize) || 1}
          </span>
          <button
            className="px-3 py-1 rounded bg-gray text-white disabled:opacity-50"
            onClick={() => pageChange((p: number) => p + 1)}
            disabled={page >= Math.ceil(total / pageSize)}
          >
            {`>`}
          </button>
        </div>
      )}
    </div>
  );
};

export default AgGridTable;
